<script setup>
import { useFetch } from '#app'
import { onMounted } from 'vue'

// Props definition
const props = defineProps({
  pageId: {
    type: Number,
    required: true,
  },
})

// Fetch data
const { data: pageData, error } = await useFetch(
  `/api/wagtail/pages/${props.pageId}/`,
)

if (error.value) {
  console.error('exception wagtail', error.value)
  Sentry.captureException(error.value)
  throw error.value
}

// Reactive state
const pageBody = computed(() => pageData.value?.body || '')
const pageTitle = computed(() => pageData.value?.title || '')
const jotForm = computed(() => pageData.value?.jot_form || '')

// Mounted hook
onMounted(() => {
  if (jotForm.value) {
    // Hide title if no body is entered for the page
    if (!pageBody.value) pageData.value.title = ''

    const script = document.createElement('script')
    const doc = new DOMParser().parseFromString(jotForm.value, 'text/html')
    const src = doc.getElementsByTagName('script')[0].src
    script.setAttribute('src', src)
    document.head.appendChild(script)
  }
})
</script>

<template>
  <div>
    <h1 id="wagtail-page-title" v-html="pageTitle"></h1>
    <div class="wagtail" v-html="pageBody"></div>
    <div v-html="jotForm"></div>
  </div>
</template>
